/* eslint-disable jsx-a11y/media-has-caption */
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Hls from 'hls.js';
import styles from './Video.module.css';

function Carousel({ item, type }) {

  const videoRef = useRef();

  useEffect((
  ) => {

    const _hls = new Hls({
      autoStartLoad: true,
      maxBufferLength: 10,
      startFragPrefetch: true,
    });
    if (!item?.url?.includes('.m3u8')) {

      videoRef.current.src = item?.url;
      return;
    
    }
    if (Hls.isSupported()) {

      _hls.attachMedia(videoRef.current);
      _hls.on(Hls.Events.MEDIA_ATTACHED, () => {

        _hls.loadSource(item?.url);
      
      });
      _hls.on(Hls.Events.ERROR, (event, data) => {

        if (data.fatal) {

          switch (data.type) {

            case Hls.ErrorTypes.NETWORK_ERROR:
              // try to recover network error
              _hls.startLoad();
              break;
            case Hls.ErrorTypes.MEDIA_ERROR:
              _hls.recoverMediaError();
              break;
            default:
              // cannot recover
              _hls.destroy();
              break;
          
          }
        
        }
      
      });
    
    } else if (videoRef?.current?.canPlayType('application/vnd.apple.mpegurl')) {

      videoRef.current.src = item?.url;
    
    }
  
  }, []);

  return (
    <video
      ref={videoRef}
      className={type ? styles.preview : styles.fullWidth}
      controls={!type}
      poster={item.preview}
      playsInline={true}
      muted="false"
      preload="auto"
    />
  );

}

Carousel.propTypes = {
  item: PropTypes.object.isRequired,
  type: PropTypes.bool,
};

Carousel.defaultProps = {
  type: false,
};

export default Carousel;
